<template>
    <div
        class="group my-4 rounded-lg border-iron-200 bg-white px-4 py-5 shadow-sm hover:shadow-md w-full border transition-all duration-200"
    >
        <div class="space-x-3 sm:flex items-center justify-between">
            <div class="w-6 relative">
                <span
                    class="-top-2 left-2 h-3 w-3 bg-purple-500 absolute rounded-full"
                ></span>
                <span
                    class="-top-2 left-2 h-3 w-3 animate-ping bg-purple-500 absolute rounded-full"
                ></span>
            </div>
            <div class="gap-2 flex w-full items-center justify-between">
                <div>
                    <p class="font-medium text-iron-700">
                        {{ $t("teams.team_invitation.title") }}
                    </p>
                    <!-- <p class="font-medium text-iron-700"> -->
                    <!--     {{ invitation.team.name }} -->
                    <!--     <span class="text-xs text-iron-500"> -->
                    <!--         {{ $t("teams.invite_card.as") }} -->
                    <!--         {{ invitation.role }} -->
                    <!--     </span> -->
                    <!-- </p> -->

                    <p class="text-sm tracking-tight text-iron-700">
                        {{
                            $t("teams.team_invitation.description", {
                                name: "Natali Craig",
                                team: invitation.team.name,
                                role: capitalize(invitation.role),
                            })
                        }}
                    </p>
                </div>
                <div class="gap-2 flex">
                    <Button
                        size="sm"
                        @click="declineInvitation"
                        variant="ghost"
                    >
                        {{ $t("teams.team_invitation.dismiss") }}
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        class="gap-2 text-iron-600"
                        @click="acceptInvitation"
                    >
                        <Check class="text-iron-500" :size="20" />
                        {{ $t("teams.team_invitation.join") }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { Button } from "@/components/ui/button";
import type { TeamInvitation } from "../types/Team";
import { Check } from "lucide-vue-next";
import { capitalize } from "@/utils/capitalize";

const { show } = useConfirm();
const { t } = useI18n();

interface Props {
    invitation: TeamInvitation;
}
const props = defineProps<Props>();

async function acceptInvitation() {
    router.post(
        route("app.teams.invitations.accept", {
            invitation: props.invitation.id,
        }),
    );
}

async function declineInvitation() {
    const success = await show({
        header: t("teams.invite_card.decline_confirmation_title"),
        message: t("teams.invite_card.decline_confirmation_description"),
        cancel: t("teams.invite_card.decline_confirmation_action"),
    });

    if (success) {
        router.delete(
            route("app.teams.invitations.decline", {
                invitation: props.invitation.id,
            }),
        );
    }
}
</script>
